module.exports = __webpack_public_path__ + "static/warrior_icon-0f256204c9722662c503862d5a652fe5.png";